export const getInstancesByProductQuery = `query GetCanonicals ($org_id: String! $product_id: [String] $since: String! $before: String! $operation_type: String) {
        products (
          org_id: $org_id,
          product_id: $product_id,
          since: $since,
          before: $before,
          operation_type: $operation_type,
          is_composite: true,
          limit: "10000"
        ) 
        {
            description,
            total_instance_count,
            aliases{
                id
                system_type
            }
            instances{
                id,
                product_type,
                parent_operation{
                    id,
                    organization_ref,
                    organization_name,
                    farms {
                        id,
                        description
                    },
                    parties{
                        name
                    },
                    document_type,
                    integration_account_ref,
                    fields {
                        id,
                        aliases {
                            id,
                            model_scope,
                            system_type,
                            instance_system_id,
                        },
                        description,
                        grower_ref,
                        farm_ref,
                        is_resolved
                    },
                    operation_types,
                    start_date_time,
                    end_date_time
                }
            }
        }
    }`;
